import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  getListQuanLyThuChiHopDong,
  updateDataSearch,
} from "../../../actions/QuanLyThuChiHopDong";
import { formatNumber } from "utils/currencyFormat";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import ReactDropdown from "react-dropdown";
import { ThuChiHopDongCombo } from "../../../constants/thuChiHopDongConst";
import userApi from "service/userApi";
import { formatDayMonth } from "utils/formatDate";
import { currentDate } from "utils/formatDate";
import { convertDate } from "utils/formatDate";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import CuaHangDoiTacApi from "service/cuaHangDoiTacApi";
import DoiTinhTrangNoApi from "service/doiTinhTrangNoApi";
import useHinhThucThanhToan from "utils/useHinhThucThanhToan";

export const SearchDesktop = ({ isHoaHongTraGop }) => {
  const dispatch = useDispatch();
  const batHinhThucThanhToan = useHinhThucThanhToan();
  const [loaiThuChi, setLoaiThuChi] = useState(ThuChiHopDongCombo.LoaiVayCombo);
  const initKieuVay = {
    kieuVayOption: [
      { value: "0", label: "Tất cả" },
      { value: "3", label: "Cầm đồ" },
      { value: "1", label: "Tín chấp" },
      { value: "2", label: "Trả góp" },
      { value: "4", label: "Nhận Vay" },
      { value: "5", label: "Bán hàng trả góp" },
    ],
  };
  const [dataKieuVay, setDataKieuVay] = useState(initKieuVay.kieuVayOption);
  const initNguonKhachHang = {
    listNguonKhachHang: [
      {
        label: "Tất cả",
        value: 0,
      },
    ],
  };
  const [nguonkhachhang, setNgonKhachHang] = useState(
    initNguonKhachHang.listNguonKhachHang
  );

  const DanhSachCombo = {
    nhanVienOption: [],
  };
  const [lstTinhTrangNo, setLstTinhTrangNo] = useState([]);
  useEffect(() => {
    //Code lấy list user
    userApi.combo().then((response) => {
      const dataComboUser = response.data.map((item) => ({
        value: item.value,
        label: item.label,
      }));
      setListUser(dataComboUser);
    });

    CuaHangDoiTacApi.combo().then((response) => {
      const dataComDoiTac = response.data.map((item) => ({
        value: item.value,
        label: item.label,
      }));
      setNgonKhachHang(dataComDoiTac);
    });
    DoiTinhTrangNoApi.getListTinhTrangNo().then((response) => {
      if (response.status === 200) {
        const dataComboTinhTrang = response.data.map((item) => ({
          value: item.Code,
          label: item.Name,
        }));
        const dataComboTinhTrangNew = [
          { value: "-1", label: "Tất cả" },
          ...dataComboTinhTrang,
        ];
        setLstTinhTrangNo(dataComboTinhTrangNew);
      }
    });
  }, []);

  const [listUser, setListUser] = useState(DanhSachCombo.nhanVienOption);

  const dataSearch = useSelector(
    (state) => state.dataSearchQuanLyThuChiHopDong
  );

  const updateState = (field, text) => {
    dispatch(
      updateDataSearch({
        ...dataSearch,
        [field]: text,
      })
    );
  };

  const updateTextValue = (field) => (e) => {
    updateState(field, e.target.value);
  };

  const updateDropdown = (field) => (e) => {
    //alert("tuty");
    // console.log(e.target.value);
    updateState(field, e.target.value);
  };

  const onChangeDate = (field) => (evt) => {
    updateState(field, formatDayMonth(evt));
  };

  const onSearch = () => {
    dataSearch.pageIndex = 1;
    dispatch(getListQuanLyThuChiHopDong(dataSearch));
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      dispatch(
        updateDataSearch({
          ...dataSearch,
          pageIndex: 1,
        })
      );
      dispatch(getListQuanLyThuChiHopDong(dataSearch));
    }
  }; //sự kiện tìm kiếm enter

  // convert sự kiện tìm kiếm từ ngày đến ngày
  // convert sự kiện tìm kiếm từ ngày đến ngày
  var tuNgay = currentDate();
  if (dataSearch.tuNgay === "01/01/2001") tuNgay = "";
  else tuNgay = dataSearch.tuNgay;
  var denNgay = currentDate();
  if (dataSearch.denNgay === "01/01/4000") denNgay = "";
  else denNgay = dataSearch.denNgay;
  denNgay = convertDate(denNgay);
  tuNgay = convertDate(tuNgay);
  return (
    <div className="search-new hidden-mobile-main show-table-main">
      <div className="input-sm-new input-new-18">
        <label className="font-color-default font-bold">Tìm kiếm</label>
        <input
          type="text"
          className="form-control input-sm"
          placeholder="Mã hợp đồng, tên khách hàng"
          value={dataSearch.ten}
          onChange={updateTextValue("ten")}
          onKeyDown={handleKeyDown}
        />
      </div>
      <div className="input-sm-new input-new-18">
        <label className="font-color-default font-bold">Từ ngày</label>
        <DateTimePicker
          value={tuNgay}
          onChange={onChangeDate("tuNgay")}
          placeholder="Từ ngày"
          name="tuNgay"
        ></DateTimePicker>
      </div>
      <div className="input-sm-new input-new-18">
        <label className="font-color-default font-bold">Đến ngày</label>
        <DateTimePicker
          value={denNgay}
          onChange={onChangeDate("denNgay")}
          placeholder="Đến ngày"
          name="denNgay"
        ></DateTimePicker>
      </div>

      <div className="input-sm-new input-new-18">
        <label className="font-color-default font-bold">Nhân viên</label>
        <select
          name="nhanvien"
          className="selectBox form-control input-sm"
          value={dataSearch.nhanvien}
          onChange={updateDropdown("nhanvien")}
        >
          {listUser &&
            listUser.map((item, idx) => (
              <option key={"objComboStore1" + idx} value={item.value}>
                {item.label}
              </option>
            ))}
        </select>
      </div>

      <div className="input-sm-new input-new-18">
        <label className="font-color-default font-bold">Kiểu vay</label>
        <select
          name="kieuvay"
          className="selectBox form-control input-sm"
          value={dataSearch.kieuvay}
          onChange={updateDropdown("kieuvay")}
        >
          {dataKieuVay &&
            dataKieuVay.map((item, idx) => (
              <option key={"objComboStore1" + idx} value={item.value}>
                {item.label}
              </option>
            ))}
        </select>
      </div>

      <div className="input-sm-new input-new-18">
        <label className="font-color-default font-bold">Loại thu chi</label>
        <select
          name="loaithuchi"
          className="selectBox form-control input-sm"
          value={dataSearch.loaithuchi}
          onChange={updateDropdown("loaithuchi")}
        >
          {loaiThuChi &&
            loaiThuChi.map((item, idx) => (
              <option key={"objComboStore1" + idx} value={item.value}>
                {item.label}
              </option>
            ))}
        </select>
      </div>
      <div className="input-sm-new input-new-18">
        <label className="font-color-default font-bold">Tình trạng nợ</label>
        <select
          name="tinhtrangno"
          className="selectBox form-control input-sm"
          value={dataSearch.tinhtrangno}
          onChange={updateDropdown("tinhtrangno")}
        >
          {lstTinhTrangNo &&
            lstTinhTrangNo.map((item, idx) => (
              <option key={"objComboStore1" + idx} value={item.value}>
                {item.label}
              </option>
            ))}
        </select>
      </div>
      {isHoaHongTraGop && (
        <div className="input-sm-new input-new-18">
          <label className="font-color-default font-bold">
            Kênh thanh toán
          </label>
          <select
            name="kenhthanhtoan"
            className="selectBox form-control input-sm"
            value={dataSearch.kenhthanhtoan}
            onChange={updateDropdown("kenhthanhtoan")}
          >
            <option value={"-1"}>Tất cả kênh thanh toán</option>
            {nguonkhachhang &&
              nguonkhachhang.map((item, idx) => (
                <option key={"objComboStore1" + idx} value={item.value}>
                  {item.label}
                </option>
              ))}
          </select>
        </div>
      )}
      {batHinhThucThanhToan && (
        <div className="input-sm-new input-new-18">
          <label className="font-color-default font-bold">
            Hình thức thanh toán
          </label>
          <select
            name="hinhThucThanhToan"
            className="selectBox form-control input-sm"
            value={dataSearch.hinhThucThanhToan ?? "-1"}
            onChange={updateDropdown("hinhThucThanhToan")}
          >
            <option value="-1">Tất cả</option>
            <option value="0">Tiền mặt</option>
            <option value="1">Chuyển khoản</option>
          </select>
        </div>
      )}
      <div className="input-sm-new input-new-18 search-main-new">
        <button
          type="submit"
          className="btn btn-info-new btn-seach-ds"
          onClick={onSearch}
        >
          <i className="la la-search"></i>
          <span className="search-label"> &nbsp; Tìm kiếm</span>
        </button>
      </div>
    </div>
  );
};
